import { Button } from '@shipengine/giger';
import { useTranslation } from '@packlink/translation-provider';
import { useTenantConfig } from '@packlink/tenant-config-provider';
import { useHelpCenter } from '@packlink/provider';

export const PaypalErrorPage = (): JSX.Element => {
    const { t } = useTranslation();
    const getSupportPage = useHelpCenter();

    const {
        externalPages: { home: homeUrl },
    } = useTenantConfig<ITenantConfig>();

    return (
        <>
            <h1 className="error-content__title">{t('error.ops.title')}</h1>
            <p className="error-content__text">{t('error.common.message')}</p>
            <div className="error-block">
                <div className="error-block__item">
                    <Button onClick={() => reloadPage(homeUrl)}>{t('error.link.go-back-paypal')}</Button>
                </div>
                <div className="error-block__item">
                    <p>
                        <b>{t('need.help')}</b>
                    </p>
                    <p
                        dangerouslySetInnerHTML={{
                            __html: t('visit.help.center', {
                                href: getSupportPage(),
                            }),
                        }}
                    />
                </div>
            </div>
        </>
    );
};

const reloadPage = (homeUrl: string): void => {
    window.location.replace(homeUrl);
};
